import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "details", "titleText"];
import React from 'react';
import { View, Spacer } from "../../layout";
import { Text } from "../../text";
import BoxContainer from "./BoxContainer";
import { jsx as ___EmotionJSX } from "@emotion/core";

var DetailedBox = function DetailedBox(_ref) {
  var children = _ref.children,
      details = _ref.details,
      titleText = _ref.titleText,
      boxContainerProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(BoxContainer, boxContainerProps, ___EmotionJSX(View, {
    alignItems: "center",
    justifyContent: "space-between",
    maxWidth: "calc(100% - 40px)"
  }, ___EmotionJSX(Text, {
    fontSize: "T200",
    fontWeight: "medium"
  }, titleText), children), details && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Spacer, {
    height: "S200"
  }), typeof details === 'string' ? ___EmotionJSX(Text, {
    fontSize: "T100"
  }, details) : ___EmotionJSX(View, null, details)));
};

DetailedBox.displayName = 'DetailedBox';
export default DetailedBox;